import * as yup from 'yup'
import { ApplicationFormAnswers } from '../components/ApplicationForm/ApplicationFormContext'
import VehicleTypeOptions from '../components/Questions/VehicleTypeQuestion/VehicleTypeOptions'
import BaseValidator from './BaseValidator'

const VehicleTypeValidator = (): BaseValidator => {
  const schema = yup.object().shape({
    vehicleType: yup.string()
      .oneOf(VehicleTypeOptions.map((o) => o.value))
      .required()
  })

  return {
    getValidator: () => schema,
    validateState: (state: ApplicationFormAnswers) => schema.isValidSync({
      vehicleType: state.vehicleType
    })
  }
}

export default VehicleTypeValidator
